import React from "react";
import { Star, Quote } from "lucide-react";

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: "Ana Silva",
      location: "Braga",
      text: "Ambiente excepcional e profissionais de primeira qualidade. Os tratamentos faciais deixaram a minha pele radiante. Recomendo vivamente!",
      rating: 5,
      service: "Tratamento Facial"
    },
    {
      name: "Carlos Mendes",
      location: "Guimarães",
      text: "A massagem terapêutica foi transformadora. Senti-me completamente renovado. O espaço é muito acolhedor e relaxante.",
      rating: 5,
      service: "Massagem Terapêutica"
    },
    {
      name: "Maria Santos",
      location: "Braga",
      text: "Adoro vir à Fonte de Juvence! A equipa é fantástica e os resultados dos tratamentos corporais são visíveis. Já sou cliente há 3 anos.",
      rating: 5,
      service: "Tratamentos Corporais"
    },
    {
      name: "João Oliveira",
      location: "Vila Nova de Famalicão",
      text: "Excelente atendimento e instalações de luxo. O tratamento de spa foi uma experiência única. Voltarei certamente!",
      rating: 5,
      service: "SPA Experience"
    },
    {
      name: "Rita Costa",
      location: "Barcelos",
      text: "Profissionais muito competentes e ambiente muito clean. Os tratamentos de estética avançada superaram as minhas expectativas.",
      rating: 5,
      service: "Estética Avançada"
    },
    {
      name: "Pedro Ferreira",
      location: "Braga",
      text: "Centro muito bem localizado e com excelentes condições. A equipa é muito atenciosa e os preços são justos para a qualidade oferecida.",
      rating: 5,
      service: "Geral"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-sage-dark mb-6">
            O Que Dizem os Nossos Clientes
          </h2>
          <p className="text-xl text-sage-medium max-w-3xl mx-auto leading-relaxed">
            A satisfação dos nossos clientes é a nossa maior recompensa. 
            Veja o que dizem sobre a experiência na Fonte de Juvence.
          </p>
          
          {/* Rating Summary */}
          <div className="flex items-center justify-center mt-8 space-x-4">
            <div className="flex items-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-gold-warm text-gold-warm" />
              ))}
            </div>
            <div className="text-lg font-semibold text-sage-dark">4.9/5</div>
            <div className="text-sage-medium">•</div>
            <div className="text-sage-medium">4,925 avaliações</div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-cream-light rounded-3xl p-6 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-gold-warm text-gold-warm" />
                  ))}
                </div>
                <Quote className="w-6 h-6 text-gold-warm opacity-50" />
              </div>
              
              <p className="text-sage-dark mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>
              
              <div className="border-t border-sage-soft/30 pt-4">
                <div className="flex justify-between items-start">
                  <div>
                    <h4 className="font-semibold text-sage-dark">{testimonial.name}</h4>
                    <p className="text-sm text-sage-medium">{testimonial.location}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-gold-warm font-semibold uppercase tracking-wide">
                      {testimonial.service}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust indicators */}
        <div className="mt-16 text-center">
          <div className="bg-sage-soft/20 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-playfair font-bold text-sage-dark mb-6">
              Juntam-se a milhares de clientes satisfeitos
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-gold-warm mb-2">4,925</div>
                <div className="text-sage-medium text-sm">Avaliações</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gold-warm mb-2">4.9★</div>
                <div className="text-sage-medium text-sm">Classificação</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gold-warm mb-2">15+</div>
                <div className="text-sage-medium text-sm">Anos</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-gold-warm mb-2">95%</div>
                <div className="text-sage-medium text-sm">Recomendam</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;